<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 搜索表单 -->
      <a-form layout="inline" style="margin-bottom: 24px">
        <a-form-item label="商品名称">
          <a-input v-model="query.goodsName" placeholder="请输入商品名称" allow-clear style="width: 200px" />
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker v-model="dateRange" style="width: 300px" @change="handleDateChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>

      <!-- 概览卡片 -->
      <a-row :gutter="16" style="margin-bottom: 24px">
        <a-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="商品总数"
              :value="overview.totalGoodsCount"
              :precision="0"
            />
          </a-card>
        </a-col>
        <a-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="总要货数量"
              :value="overview.totalPurchaseQuantity"
              :precision="0"
            />
          </a-card>
        </a-col>
        <a-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="门店拿货总金额(元)"
              :value="overview.totalStoreCostAmount"
              :precision="2"
              prefix="¥"
            />
          </a-card>
        </a-col>
        <a-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="商家总利润(元)"
              :value="overview.totalMerchantProfit"
              :precision="2"
              prefix="¥"
              :value-style="{ color: '#1890ff' }"
            />
          </a-card>
        </a-col>
      </a-row>

      <!-- 商品利润统计表 -->
      <a-card title="商品利润统计" :bordered="false">
        <a-table
          :columns="goodsProfitColumns"
          :data-source="goodsProfitList"
          :loading="loading"
          :pagination="{
            current: query.pageNo,
            pageSize: query.pageSize,
            total: total,
            showSizeChanger: true,
            showTotal: total => `共 ${total} 条`
          }"
          size="small"
          rowKey="goodsId"
          @change="handleTableChange"
        >
          <template slot="merchantCost" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="storeCost" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="salesAmount" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="merchantProfit" slot-scope="text">
            <span :style="{ color: text >= 0 ? '#1890ff' : '#cf1322' }">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
          </template>
        </a-table>
      </a-card>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getMerchantGoodsProfitStatistics } from '@/api/retail/statistics'
import moment from 'moment'

export default {
  name: 'MerchantGoodsProfitStatistics',
  data() {
    return {
      dateRange: [],
      query: {
        goodsName: undefined,
        categoryName: undefined,
        startDate: undefined,
        endDate: undefined,
        pageNo: 1,
        pageSize: 10
      },
      overview: {
        totalGoodsCount: 0,
        totalPurchaseQuantity: 0,
        totalMerchantCostAmount: 0,
        totalStoreCostAmount: 0,
        totalMerchantProfit: 0
      },
      goodsProfitList: [],
      loading: false,
      total: 0,
      goodsProfitColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 180, align: 'center' },
        { title: '要货单数', dataIndex: 'purchaseOrderCount', width: 100, align: 'center' },
        { title: '要货数量', dataIndex: 'purchaseQuantity', width: 100, align: 'center' },
        { title: '商家成本价(元)', dataIndex: 'merchantCost', width: 120, align: 'center', scopedSlots: { customRender: 'merchantCost' } },
        { title: '门店成本价(元)', dataIndex: 'storeCost', width: 120, align: 'center', scopedSlots: { customRender: 'storeCost' } },
        { title: '门店销售价(元)', dataIndex: 'salesAmount', width: 120, align: 'center', scopedSlots: { customRender: 'salesAmount' } },
        { title: '商家利润(元)', dataIndex: 'merchantProfit', width: 120, align: 'center', scopedSlots: { customRender: 'merchantProfit' } },
        { title: '最后要货时间', dataIndex: 'lastPurchaseTime', width: 180, align: 'center' }
      ]
    }
  },
  mounted() {
    this.loadStatistics()
  },
  methods: {
    loadStatistics() {
      this.loading = true
      getMerchantGoodsProfitStatistics(this.query).then(response => {
        console.log('商家商品利润统计数据:', response)
        this.goodsProfitList = response.data?.records || []
        this.total = response.data?.total || 0
        // 确保概览数据不为null
        const overview = response.data?.overview
        if (overview) {
          this.overview = {
            totalGoodsCount: overview.totalGoodsCount || 0,
            totalPurchaseQuantity: overview.totalPurchaseQuantity || 0,
            totalMerchantCostAmount: overview.totalMerchantCostAmount || 0,
            totalStoreCostAmount: overview.totalStoreCostAmount || 0,
            totalMerchantProfit: overview.totalMerchantProfit || 0
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleDateChange(dates, dateStrings) {
      this.query.startDate = dateStrings[0]
      this.query.endDate = dateStrings[1]
    },
    handleSearch() {
      this.query.pageNo = 1
      this.loadStatistics()
    },
    handleReset() {
      this.query = {
        goodsName: undefined,
        categoryName: undefined,
        startDate: undefined,
        endDate: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.dateRange = []
      this.loadStatistics()
    },
    handleTableChange(pagination) {
      this.query.pageNo = pagination.current
      this.query.pageSize = pagination.pageSize
      this.loadStatistics()
    }
  }
}
</script>

<style scoped>
.stat-card {
  margin-bottom: 0;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-card >>> .ant-statistic-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

.stat-card >>> .ant-statistic-content {
  font-size: 24px;
  font-weight: 600;
}
</style>
